module.exports = __webpack_public_path__ + "images/adea334123067ad9bf01187e40a37ed6.png";